<template>
  <el-dialog custom-class="list-dialog" title="采购单" :visible.sync="dialogFormVisible" center :append-to-body="true"
             :close-on-click-modal="false"
  >
    <div>
      <el-col :span="24">
        <div>
          <div class="search-content">
            <el-col :span="24" class="toobar">
              <el-col :span="4">
                <el-input placeholder="请输入订单号" v-model="searchdata" size="medium" style="width: 200px"></el-input>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-search" @click="bindGrid">搜索</el-button>
                <el-button type="primary" icon="el-icon-search" @click="getBarcode">取物流码</el-button>
              </el-col>
            </el-col>
          </div>

          <el-table
            :data="tableData"
            :height="tableHeight(151)"
            size="mini"
            stripe
            border
            style="width: 100%;"
            @selection-change="handleSelectionChange">
            <el-table-column
              width="60"
              label="序号"
              align="center">
              <template slot-scope="scope">
                {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
              </template>
            </el-table-column>
            <el-table-column
              prop="erpserial"
              label="订单号"
              align="center"
              header-align="center"
              width="140">
            </el-table-column>
            <el-table-column
              prop="seedname"
              label="商品"
              align="left"
              header-align="center">
            </el-table-column>
            <el-table-column
              prop="pcustomer"
              label="供应商"
              align="left"
              width="140"
              header-align="center"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
              prop="totalnumber"
              label="总数"
              align="right"
              header-align="center"
              width="100">
              <template slot-scope="scope">
                {{scope.row.totalnumber|numeric(0)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="handleoverdate"
              label="入库日期"
              align="center"
              header-align="center"
              width="140">
            </el-table-column>
            <el-table-column
              prop="cangkuname"
              label="仓库"
              align="center"
              header-align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              label="选择"
              align="right"
              header-align="center"
              width="70">
              <template slot-scope="scope">
                <el-button type="primary" @click="SelectOK(scope.row)" size="mini">选择</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="foot" style="text-align: center;display: none">
            <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
          </div>
        </div>
      </el-col>
    </div>
  </el-dialog>
</template>

<script>
  import {independentDept} from '@/api/set/dept';
  import {
    listOverPurchase,getJxcformdetailCost
  } from '@/api/set/csagreement';
  import {listSimp} from '@/api/set/jxcstoregoodsbarcode';

  export default {
    name: 'OrderBuyList',
    data() {
      return {
        msg: '获取采购单',
        needbarcode:false,
        dialogFormVisible: false,
        independentserial: '',
        searchdata: '',
        idd: [],//服务中心
        SelectionChange: [],//
        statuses: "",//状态
        customerserial: "",
        loading: true,
        pagination: {
          currentPage: 1,
          pageSize: 100,
          total: 0
        },
        tableData: [],
        startdate:"",
        enddate:"",
        seedcode:'',
        cangkucode:''
      }
    },
    methods: {
      handleSelectionChange(val) {
        this.SelectionChange = val;
      },
      getBarcode(){
        this.needbarcode=true;
        if(!this.searchdata) return;
        this.SelectOK({erpserial:this.searchdata});
      },
      SelectOK(row) {
        if(this.needbarcode){
          listSimp({inordernum:row.erpserial,outtime:1}).then(response => {
            this.$emit("select", response.data.obj,row.erpserial)
            this.dialogFormVisible = false;
          });
        }else {
          getJxcformdetailCost({erpserial: row.erpserial}).then(response => {
            var items = response.data.obj;
            var retD = []
            for (let i in items) {
              var pack = JSON.parse(items[i].packagesize)
              pack.P = items[i].totalnumber;
              retD.push(pack)
            }
            this.$emit("select", retD)
            this.dialogFormVisible = false;
          });
        }
      },
      show(seedcode,cangkucode,needbarcode) {
        this.seedcode = seedcode;
        this.needbarcode=needbarcode;
        this.cangkucode = cangkucode;
        this.searchdata="";

        //批量推送唯一码
        // this.searchdata="231222"+seedcode;
        // this.getBarcode();
        // return;


        this.dialogFormVisible = true;
        this.initform()
        this.bindGrid()
      },
      //数据源
      bindGrid() {
        this.tableData = []
        listOverPurchase({
          seedcode: this.seedcode,
          cangkucode: this.cangkucode,
          erpserial:this.searchdata
        }).then(response => {
          this.tableData = response.data.obj;
        }).catch((error) => {
        });
      },
      initform() {
        this.searchdata = ''
        this.tableData = []
      }
    },
    mounted() {
    },
    components: {}

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/voucher/OrderBuyList.vue